<template>
  <z-expansion-config-item 
    titulo="Forma de Pagamento Padrão" 
    subtitulo="Selecione a forma de pagamento padrão do sistema na venda"
  >
    <v-select
      v-model="store.configuracoes.FORMA_PAGAMENTO_PADRAO"
      dense
      filled
      hide-details
      style="width: 200px"
      :items="globals.FORMAS_DE_PAGAMENTO"
      @change="updateConfig"
    ></v-select>
  </z-expansion-config-item>
</template>

<script setup>
import { useConfigStore } from '@/app/store/pinia/configuracoes'
import { globals } from '@/app/globals'

const store = useConfigStore();

function updateConfig() {
  store.salvarConfiguracao({
    config: 'FORMA_PAGAMENTO_PADRAO',
    valor: store.configuracoes.FORMA_PAGAMENTO_PADRAO,
    tipo: 'string',
    descricao: 'Forma de Pagamento Padrão',
    ajuda: 'Selecione a forma de pagamento padrão do sistema na venda'
  });
}

</script>

<style lang="scss" scoped>

</style>
